import { render, staticRenderFns } from "./InstitutionalOpen.vue?vue&type=template&id=8fac70c4&scoped=true&"
import script from "./InstitutionalOpen.vue?vue&type=script&lang=ts&"
export * from "./InstitutionalOpen.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionalOpen.vue?vue&type=style&index=0&id=8fac70c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac70c4",
  null
  
)

export default component.exports